import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=79e97228"
import script from "./statistics.ts?vue&type=script&lang=ts&external"
export * from "./statistics.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports